import React from 'react'
import {Button, Inline, Loading} from '@therms/atalaya'
import {PlusIcon} from '@heroicons/react/24/solid'
import ChatPanel from './components/ChatPanel'
import ThreadListPanel from './components/ThreadListPanel'
import {useMessagesPanel} from '../../../hooks/useMessagesPanel'
import {SelectPositions} from '@src/modules/Positions/shared/Fields/SelectPositions'
import {useAutoSavePositions} from '@src/hooks/useAutoSavePositions'

function MessagesIndex() {
  const {
    isSelectingUser,
    users,
    handleSelectUser,
    handleCancelSelectUser,
    data,
    selectedThreadId,
    handleSelectMessage,
    recordsPerPage,
    offset,
    setOffset,
    selectedUser,
    threadMessages,
    currentSiteUser,
    textInput,
    setTextInput,
    handleSendMessage,
    isCalling,
    isFetchingThreadMessages,
    isFetchingUsers,
    handleStartNewMessage,
  } = useMessagesPanel(8)

  const { selectedPositions, handlePositionChange, isSaving } = useAutoSavePositions()
  return (
    <div className="relative">
      <Loading overlay visible={isCalling && !data?.threads?.length} />
      <Loading overlay visible={isFetchingThreadMessages && !threadMessages?.messages?.length} />
      <Loading overlay visible={isFetchingUsers && !users?.length} />
      <Inline alignX="between" alignY="center" className="pb-3" width="full">
        <div className="text-lg font-semibold">Messages</div>
        <div className='flex items-center gap-2'>
          <div className='flex items-center gap-2'>
            <SelectPositions
              label=""
              multi
              name="notifyPositionIds"
              value={selectedPositions}
              onChangeValue={handlePositionChange}
              placeholder="Select positions to receive email notifications..."
            />
            {isSaving && (
              <div className="text-xs text-gray-500">
                Saving...
              </div>
            )}
          </div>
          {!isSelectingUser && (
            <Button
              variant="main"
              className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-md shadow"
              onClick={handleStartNewMessage}
            >
              <PlusIcon className="w-5 h-5 mr-1" />
              Send Message
            </Button>
          )}
        </div>
      </Inline>
      <div className="sm:flex-col md:flex-row md:flex gap-6 mt-4 min-h-[90vh]">
        <div className="sm:w-full md:w-5/12">
          <ThreadListPanel
            isSelectingUser={isSelectingUser}
            users={users}
            handleSelectUser={handleSelectUser}
            handleCancelSelectUser={handleCancelSelectUser}
            data={data}
            selectedThreadId={selectedThreadId}
            handleSelectMessage={handleSelectMessage}
            recordsPerPage={recordsPerPage}
            offset={offset}
            setOffset={setOffset}
          />
        </div>
        <ChatPanel
          isSelectingUser={isSelectingUser}
          selectedUser={selectedUser}
          threadMessages={threadMessages}
          currentSiteUser={currentSiteUser}
          textInput={textInput}
          setTextInput={setTextInput}
          handleSendMessage={handleSendMessage}
        />
      </div>
    </div>
  )
}

export {MessagesIndex}